<template>
  <div class="distribution">
    <div class="distribution__container">
      <div class="distribution__container__chart-type" v-for="(objectData, index) of arrayDataForCharts" :key="index">
        <div class="distribution__container__chart-type__title">
          {{ objectData.name }}
        </div>
        <div class="distribution__container__chart-type__controls"></div>
        <div class="distribution__container__chart-type__chart">
          <VueApexCharts
            type="radar"
            :height="height"
            :options="arrayChartOptions[index]"
            :series="arrayFilledSeries[index]"
            :key="chartKeyCounter + updateCategory + index"
          />
        </div>
      </div>
    </div>
    <ResumeTooltip
      :data="tooltip.data"
      :local="tooltip.local"
      :names="tooltip.names"
      :keyName="tooltip.keyName"
      :leagueAvg="tooltip.leagueAvg"
      :left="tooltip.local"
      :show.sync="tooltip.show"
      :x="tooltip.x"
      :y="tooltip.y"
      :data-value="tooltip.numberValue"
      :is-percent="tooltip.booleanIsPercent"
      :is-league-avg-visible="tooltip.isLeagueAvgVisible"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import { avg } from '@/utils/league';

const distributionColors = ['#83e730', '#ff832c'];

export default {
  name: 'Distribution',
  components: {
    VueApexCharts,
    ResumeTooltip: () => import('@/components/Elements/NextMatches/ResumeTooltip'),
  },
  data() {
    return {
      arrayChartTypes: ['General', 'Ofensivo', 'Defensivo', 'Posesión', 'Balón parado', 'Infracciones'],
      height: 509,
      updateCategory: 0,
      homeTeamSelectedPlaysType: 0,
      visitingTeamSelectedPlaysType: 0,
      chartKeyCounter: 0,
      homeTeamPlaysTypes: {
        history: 0,
        live: 1,
      },
      visitingTeamPlaysTypes: {
        history: 0,
        live: 1,
      },
      tooltip: {
        show: false,
        data: {},
        names: {},
        keyName: '',
        leagueAvg: '',
        showLiveData: false,
        local: false,
        x: 0,
        y: 0,
      },
      globals: {
        x: 0,
        y: 0,
      },
      arrayDataForCharts: [],
      arrayChartOptions: [],
      arrayFilledSeries: [],
    };
  },
  watch: {
    menuOptionActive() {
      if (this.idAssetSelected == 3) {
        // setTimeout(() => {
        //   var existElement = document.getElementsByClassName('apexcharts-svg');
        //   if (existElement.length > 0) {
        //     document.getElementsByClassName('apexcharts-svg')[0].style.width = 998 + 'px';
        //   }
        // }, 400);
        // this.updateCategory++;
      }
    },
    idAssetSelected() {
      if (this.idAssetSelected === 3) {
        this.chartKeyCounter++;
      }
    },
    isMobile(newValue) {
      this.chartOptions.legend.horizontalAlign = newValue ? 'center' : 'left';
      this.chartKeyCounter++;
    },
    arrayFilledDataSortedByPriority: {
      immediate: true,
      deep: true,
      handler() {
        // const arrayFilledDataByPriority = Object.values(newValue).sort((a, b) => a.priority - b.priority);
        this.fillData();
      },
    },
    showLiveData() {
      this.fillData();
    },
  },
  computed: {
    ...mapState('nextGeneral', ['showLiveData', 'gameForAnalysis']),
    ...mapGetters('nextGeneral', [
      'idAssetSelected',
      'menuOptionActive',
      'homeTeamStatisticsType',
      'showPostMatchData',
      'visitingTeamStatisticsType',
      'homeTeam',
      'visitingTeam',
      'subcategoryName',
      'accomplished',
      'arrayFilledDataSortedByPriority',
      'filledDataStructure',
      'showPostMatchData',
    ]),
    isMobile() {
      return this.$mq === 'mobile';
    },
  },
  methods: {
    fillData() {
      this.arrayChartOptions = [];
      if (
        this.arrayFilledDataSortedByPriority &&
        this.arrayFilledDataSortedByPriority.length &&
        typeof this.arrayFilledDataSortedByPriority[0].subcategories === 'object'
      ) {
        this.arrayChartOptions = [];
        this.arrayFilledSeries = [];
        this.arrayDataForCharts = this.arrayFilledDataSortedByPriority.map(objectData => {
          const objectChartOptions = this.getChartOptions();
          this.arrayFilledSeries.push(this.getChartSeries(objectData.subcategories, objectChartOptions));
          this.arrayChartOptions.push(objectChartOptions);
          return objectData;
        });
      } else {
        this.arrayDataForCharts = [];
      }
    },
    getChartOptions() {
      return {
        plotOptions: {
          radar: {
            size: 150,
            polygons: {
              strokeColors: '#dcdcdc',
            },
          },
        },
        chart: {
          type: 'radar',
          height: 509,
          toolbar: {
            show: false,
          },
        },
        colors: distributionColors,
        fill: {
          colors: distributionColors,
          opacity: 0.2,
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'left',
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: '16px',
              fontFamily: 'Avenir-Demi',
            },
          },
        },
        yaxis: {
          show: false,
        },
        responsive: [
          {
            breakpoint: 770,
            options: {
              chart: {
                height: 300,
              },
              plotOptions: {
                radar: {
                  size: 100,
                  offsetY: 10,
                  polygons: {
                    strokeColors: '#dcdcdc',
                  },
                },
                bar: {
                  horizontal: false,
                },
              },
              legend: {
                position: 'top',
                horizontalAlign: 'center',
              },
              xaxis: {
                labels: {
                  show: true,
                  style: {
                    fontSize: '14px',
                  },
                },
              },
            },
          },
          {
            breakpoint: 450,
            options: {
              plotOptions: {
                radar: {
                  size: 70,
                  offsetY: -20,
                  polygons: {
                    strokeColors: '#dcdcdc',
                  },
                },
                bar: {
                  horizontal: false,
                },
              },
              legend: {
                position: 'top',
                horizontalAlign: 'center',
              },
              xaxis: {
                labels: {
                  show: true,
                  style: {
                    fontSize: '12px',
                  },
                },
              },
            },
          },
        ],
        tooltip: {
          intersect: true,
          shared: false,
          custom: ({ w, dataPointIndex, seriesIndex }) => {
            this.showModal(w, dataPointIndex, seriesIndex);
            return null;
          },
        },
      };
    },
    getChartSeries(objectSubcategories, objectChartOptions) {
      let local;
      let visit;
      if (!this.showPostMatchData) {
        local = {
          name: `${this.showLiveData ? 'Live' : 'Histórico'} ${this.homeTeam.acronym}`,
          data: [],
        };
        visit = {
          name: `${this.showLiveData ? 'Live' : 'Histórico'} ${this.visitingTeam.acronym}`,
          data: [],
        };
        objectChartOptions.arraySubcategories = [];
        Object.values(objectSubcategories).forEach((subcategory, index) => {
          objectChartOptions.xaxis.categories.push(this.prepareLabels(subcategory, index));
          objectChartOptions.arraySubcategories.push(subcategory);
          let homeTeamCategoryData;
          let visitingTeamCategoryData;
          const homeLeaderAvg = subcategory.homeTeam[this.homeTeamStatisticsType].leader.points;
          const visitingLeaderAvg = subcategory.visitingTeam[this.visitingTeamStatisticsType].leader.points;
          if (!this.showLiveData) {
            if (this.gameForAnalysis.game_status !== 1 && subcategory.generalCategoriesIds.accomplished === 3) {
              homeTeamCategoryData = subcategory.homeTeam.accomplished.avgPreGame;
            } else {
              homeTeamCategoryData = homeLeaderAvg
                ? subcategory.homeTeam[this.homeTeamStatisticsType].avgPostGame / homeLeaderAvg
                : 0;
            }
          } else {
            const totalLive =
              subcategory.homeTeam[this.homeTeamStatisticsType].totalLive +
              subcategory.visitingTeam[this.visitingTeamStatisticsType].totalLive;
            homeTeamCategoryData = totalLive
              ? subcategory.homeTeam[this.homeTeamStatisticsType].totalLive / totalLive
              : 0;
          }
          if (!this.showLiveData) {
            if (this.gameForAnalysis.game_status !== 1 && subcategory.generalCategoriesIds.accomplished === 3) {
              visitingTeamCategoryData = subcategory.visitingTeam.accomplished.avgPreGame;
            } else {
              visitingTeamCategoryData = visitingLeaderAvg
                ? subcategory.visitingTeam[this.visitingTeamStatisticsType].avgPostGame / visitingLeaderAvg
                : 0;
            }
          } else {
            const totalLive =
              subcategory.homeTeam[this.homeTeamStatisticsType].totalLive +
              subcategory.visitingTeam[this.visitingTeamStatisticsType].totalLive;
            visitingTeamCategoryData = totalLive
              ? subcategory.visitingTeam[this.visitingTeamStatisticsType].totalLive / totalLive
              : 0;
          }
          local.data.push(Math.round(120 * homeTeamCategoryData));
          visit.data.push(Math.round(120 * visitingTeamCategoryData));
        });
      } else {
        local = {
          name: `${this.homeTeam.acronym}`,
          data: [],
        };
        visit = {
          name: `${this.visitingTeam.acronym}`,
          data: [],
        };
        objectChartOptions.arraySubcategories = [];
        Object.values(objectSubcategories).forEach((subcategory, index) => {
          objectChartOptions.xaxis.categories.push(this.prepareLabels(subcategory, index));
          objectChartOptions.arraySubcategories.push(subcategory);
          const totalPostMatch =
            subcategory.homeTeam[this.homeTeamStatisticsType].totalPostGame +
            subcategory.visitingTeam[this.visitingTeamStatisticsType].totalPostGame;
          local.data.push(
            Math.round(
              120 *
                (totalPostMatch ? subcategory.homeTeam[this.homeTeamStatisticsType].totalPostGame / totalPostMatch : 0),
            ),
          );
          visit.data.push(
            Math.round(
              120 *
                (totalPostMatch
                  ? subcategory.visitingTeam[this.visitingTeamStatisticsType].totalPostGame / totalPostMatch
                  : 0),
            ),
          );
        });
      }
      return [local, visit];
    },
    onHomeTeamPlaysTypeChanged(newType) {
      this.homeTeamSelectedPlaysType = newType;
    },
    onVisitingTeamPlaysTypeChanged(newType) {
      this.visitingTeamSelectedPlaysType = newType;
    },
    getSubcategoryData(objectSubcategory, stringTeamType = 'homeTeam') {
      // possession id is 3-0
      if (objectSubcategory.id === '3-0') {
        objectSubcategory[stringTeamType].accomplished.totalLiveBothTeams =
          objectSubcategory.homeTeam.accomplished.totalLive + objectSubcategory.visitingTeam.accomplished.totalLive;
      }
      return objectSubcategory[stringTeamType].accomplished || 0;
    },
    /**
     * @author José Rafael Gutierrez
     * @param w
     * @param index
     * @param teamIndex
     * @return void
     */
    showModal(w, index, teamIndex) {
      const TEAM_TYPE = teamIndex === 0 ? 'homeTeam' : 'visitingTeam';
      const DATA = w.config.arraySubcategories[index] || {};
      // 3-0 is possession's id
      this.tooltip.isLeagueAvgVisible = DATA.id !== '3-0';
      this.tooltip.data = this.getSubcategoryData(DATA, TEAM_TYPE);
      this.tooltip.local = teamIndex === 0;
      this.tooltip.names = DATA.names;
      this.tooltip.keyName = this.subcategoryName;
      this.tooltip.leagueAvg = this.leagueAvg(DATA);
      const X = w.globals.clientX || 0;
      const Y = w.globals.clientY || 0;
      this.globals.x = X;
      this.globals.y = Y;
      this.tooltip.x = X;
      this.tooltip.y = Y > 700 ? Y - 250 : Y;
      const booleanIsPossession = DATA.generalCategoriesIds.accomplished === 3;
      if (booleanIsPossession) {
        const numberTeamsTotal = DATA.homeTeam.accomplished.avgPostGame + DATA.visitingTeam.accomplished.avgPostGame;
        this.tooltip.numberValue = numberTeamsTotal
          ? (DATA[TEAM_TYPE].accomplished.avgPostGame / numberTeamsTotal) * 100
          : 0;
        // if (this.showPostMatchData) {
        //   const numberTeamsTotal = DATA.homeTeam.accomplished.avgPostGame + DATA.visitingTeam.accomplished.avgPostGame;
        //   this.tooltip.numberValue = numberTeamsTotal
        //     ? (DATA[TEAM_TYPE].accomplished.avgPostGame / numberTeamsTotal) * 100
        //     : 0;
        // } else {
        //   this.tooltip.numberValue = this.tooltip.data.avgPostGame * 100;
        // }
      } else {
        this.tooltip.numberValue = null;
      }
      this.tooltip.booleanIsPercent = booleanIsPossession;
      this.tooltip.show = true;
    },
    /**
     * @author José Rafael Gutierrez
     * @param event
     * @return void
     */
    updateTooltip(event) {
      const DIFF_MAX = 5;
      const DIFF_X = Math.abs(event.clientX - this.globals.x);
      const DIFF_Y = Math.abs(event.clientY - this.globals.y);
      if (DIFF_X > DIFF_MAX || DIFF_Y > DIFF_MAX) this.tooltip.show = false;
    },
    prepareLabels(subcategory, index) {
      let label = subcategory.name || subcategory.names[this.subcategoryName] || subcategory.names['0-0'];
      if (index === 0) return label;
      const LIMIT = 25;
      if (label.length > LIMIT) {
        let fragments = label.split(' ');
        label = [];
        let temp = '';
        let result = '';
        let lastFragment = fragments.slice(-1)[0];
        fragments.forEach(fragment => {
          temp += ` ${fragment} `;
          if (temp.length > LIMIT) {
            label.push(result.trim());
            temp = fragment;
          }
          result = temp;
          if (lastFragment === fragment) {
            label.push(result.trim());
          }
        });
      }
      return label;
    },
    leagueAvg(subcategory) {
      if (subcategory.generalCategoriesIds.accomplished === 3) {
        return (
          (subcategory.homeTeam.accomplished.arrayRankings.reduce((accumulator, objectRankingData) => {
            return accumulator + objectRankingData.points;
          }, 0) /
            subcategory.homeTeam.accomplished.arrayRankings.length) *
          100
        ).toFixed(2);
      } else {
        return avg(subcategory, this.accomplished);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.distribution {
  width: 100%;
  display: flex;
  justify-content: center;

  &__container {
    max-width: 1000px;
    width: 100%;

    &__chart-type {
      width: 100%;
      border-radius: 7px;
      border: solid 1px #e7e7e7;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 48px;

      &:last-child {
        margin-bottom: 0;
      }

      &__title {
        margin: 0.4em;
        font-family: Avenir-Bold, sans-serif;
        font-size: 28px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #000;

        @media screen and (max-width: 470px) {
          margin: 1em;
          font-family: Avenir-Demi, sans-serif;
          font-size: 17px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
        }
      }

      &__chart {
        width: 100%;
      }
    }
  }
}
</style>
